import axios from 'axios'

/**
 * Cliente da nova API de produção (`producaoapi`).
 *
 * Substitui as chamadas diretas ao back-end legado da Bihands (Épico 24).
 * Toda requisição leva o token do SSO, guardado no localStorage pelo login.
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1'

const api = axios.create({ baseURL: API_BASE_URL })

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    // 401 = token inválido/expirado no SSO. Limpa a sessão e volta ao login,
    // em vez de deixar a tela num estado ambíguo.
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('token')
      localStorage.removeItem('perfil')
      if (window.location.pathname !== '/Login') {
        window.location.replace('/Login')
      }
    }
    return Promise.reject(error)
  }
)

/**
 * Extrai a mensagem de erro no formato da nova API
 * (`{ error: { code, message, requestId } }`), com fallback legível.
 */
export const mensagemDeErro = (error, padrao = 'Não foi possível concluir a operação.') => {
  const corpo = error?.response?.data?.error
  if (corpo?.message) {
    return corpo.requestId ? `${corpo.message} (ref: ${corpo.requestId})` : corpo.message
  }
  if (error?.response?.status === 403) {
    return 'Você não tem acesso a este recurso.'
  }
  return padrao
}

/** Normaliza `{ items, total }` da API para o formato das telas. */
export const paginado = response => ({
  result: response.data?.items ?? [],
  total: response.data?.total ?? 0,
  limit: response.data?.limit,
  offset: response.data?.offset,
})

export default api
